import { render, staticRenderFns } from "./musicUpload.vue?vue&type=template&id=5f2e5246&scoped=true"
import script from "./musicUpload.vue?vue&type=script&lang=js"
export * from "./musicUpload.vue?vue&type=script&lang=js"
import style0 from "./musicUpload.vue?vue&type=style&index=0&id=5f2e5246&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2e5246",
  null
  
)

export default component.exports